import { WORLD_STATE, saveWorldStateToStorage } from "../../../data/worldState.js";

export function applyFramePostUpdate(scene, { time, dt, dtScale, playerAttackHitbox }) {
  const p = scene.playerEntity;
  if (!p) return;

  // This runs once per render frame after 0..N fixed simulation steps.
  // Remove dead entities (keep player)
  scene.entities = scene.entities.filter(e => e === p || !e.markedForRemoval);
  scene.items = scene.items.filter(i => !i.markedForRemoval);

  WORLD_STATE.hp = p.hp;
  WORLD_STATE.lastMapId = scene.mapId;
  if (!p.dead && !p.dying && WORLD_STATE.resumeEnabled && (time - scene.lastResumeSaveAt) >= 1000) {
    scene.lastResumeSaveAt = time;
    WORLD_STATE.lastStanding = { mapId: scene.mapId, x: p.x, y: p.y };
    WORLD_STATE.lastStandingSavedAtMs = time;
    saveWorldStateToStorage();
  }

  scene.updateCam();
  scene.resolveAnimationState(dt);
  scene.syncSprite();
  scene.updateNetworking(time, dtScale);
  scene.ui?.draw(scene.playerEntity);

  // Debug rendering
  scene.debugGfx.clear();
  if (scene.showDebugHitboxes) {
    // Player hitbox
    scene.debugGfx.lineStyle(1, 0xff0000, 0.5);
    const pb = p.getBounds();
    scene.debugGfx.strokeRect(pb.x, pb.y, pb.w, pb.h);

    // Attack hitbox
    if (playerAttackHitbox) {
      scene.debugGfx.lineStyle(2, 0xff00ff, 0.8);
      scene.debugGfx.strokeRect(playerAttackHitbox.x, playerAttackHitbox.y, playerAttackHitbox.w, playerAttackHitbox.h);
    }

    // Entity hitboxes
    for (const entity of scene.entities) {
      if (entity === p || entity.dead) continue;
      scene.debugGfx.lineStyle(1, 0x00ffff, 0.6);
      const b = entity.getBounds();
      scene.debugGfx.strokeRect(b.x, b.y, b.w, b.h);
    }

    // Pickup hitboxes
    for (const item of scene.items) {
      scene.debugGfx.lineStyle(1, 0x00ff88, 0.6);
      const b = item.getBounds();
      scene.debugGfx.strokeRect(b.x, b.y, b.w, b.h);
    }

    // Collision shapes
    for (const shape of scene.collisionShapes) {
      scene.debugGfx.lineStyle(1, shape.oneWay ? 0x00ff00 : 0xffff00, 0.4);
      const v = shape.vertices;
      scene.debugGfx.beginPath();
      scene.debugGfx.moveTo(v[0].x, v[0].y);
      for (let i = 1; i < v.length; i++) scene.debugGfx.lineTo(v[i].x, v[i].y);
      scene.debugGfx.closePath();
      scene.debugGfx.strokePath();
    }

    // Ladders
    for (const ladder of scene.ladderShapes) {
      scene.debugGfx.lineStyle(1, 0x00ffff, 0.6);
      scene.debugGfx.strokeRect(ladder.x, ladder.y, ladder.w, ladder.h);
    }

    // Portals
    for (const portal of scene.portalZones) {
      scene.debugGfx.lineStyle(2, 0x9f7aea, 0.7);
      scene.debugGfx.strokeRect(portal.x, portal.y, portal.w, portal.h);
    }
  }
}
